<template>
  <div id="certificationDetail">
    <div class="weui-cells">
      <div class="weui-cell">
        <div class="weui-cell__ft">姓名</div>
        <div class="weui-cell__bd">
          <p>{{realName}}</p>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__ft">身份证</div>
        <div class="weui-cell__bd">
          <p>{{idCard}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'certificationDetail',
  data () {
    return {
      realName: '', // 真实姓名
      idCard: '' // 身份证
    }
  },
  mounted () {
    this.queryRealAuthInfo()
  },
  methods: {
    queryRealAuthInfo () { // 查询实名认证信息
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/query/real/auth/info'
        })
        .then(res => {
          if (res.success) {
            self.realName = res.data.realName
            self.idCard = res.data.cardNo
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="less">
#certificationDetail{
  .weui-cells{
    margin-top: 0;
    .weui-cell__bd{
      p{
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mine/certification/detail.vue